import { BACKEND_URL } from "../../../lib/apiBase";

export const API = `${BACKEND_URL}/api`;

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("de-CH", { dateStyle: "medium", timeStyle: "short", timeZone: "Europe/Zurich" });
};

export const isPast = (iso) => iso && new Date(iso) < new Date();

/* Convert ISO → datetime-local value (in Europe/Zurich). */
export function toLocalInput(iso) {
  try {
    const d = new Date(iso);
    const local = new Date(d.toLocaleString("en-US", { timeZone: "Europe/Zurich" }));
    const pad = (n) => String(n).padStart(2, "0");
    return `${local.getFullYear()}-${pad(local.getMonth()+1)}-${pad(local.getDate())}T${pad(local.getHours())}:${pad(local.getMinutes())}`;
  } catch { return ""; }
}
